import React from 'react'
import { Input, message } from 'antd'
import i18n from 'i18n'
import WorkspaceService from 'api/Workspace'
import { confirmBase, errorBase } from 'utils/ui'
import { isValidEmail } from './helper'
import styles from './style.module.scss'

const { TextArea } = Input

// 문의하기 확인 팝업 — 앱 표준 팝업(confirmBase, om-popup-1) 사용.
// onOk 가 reject 되면 antd confirm 이 닫히지 않으므로(실패 시 팝업 유지),
// 성공 시에만 닫히고 요청 중에는 확인 버튼이 자동 loading 처리된다.
// workspaceName 은 사용자에게 노출하지 않고 payload 로만 첨부한다.
export function openInquiryConfirm({ workspaceName, contactEmail } = {}) {
  // Input/TextArea 는 uncontrolled — 입력값은 클로저에 보관(modal.update 리렌더에도 값 유지)
  const formState = {
    contactEmail: contactEmail || '',
    inquiryMessage: '',
  }

  const canSubmit = () =>
    isValidEmail(formState.contactEmail) && formState.inquiryMessage.trim().length > 0

  // 전송 가능 여부에 따라 확인 버튼 disabled 갱신
  const refreshOkState = () => {
    modal.update({
      okButtonProps: {
        className: 'type8 h38',
        style: { minWidth: '100px' },
        disabled: !canSubmit(),
      },
    })
  }

  const buildContent = () => (
    <div className={styles.inquiryModalBody}>
      <p className={styles.description}>{i18n.t('inquiryModal.description')}</p>
      <div className={styles.field}>
        <span className={styles.label}>{i18n.t('inquiryModal.emailLabel')}</span>
        <Input
          defaultValue={formState.contactEmail}
          placeholder={i18n.t('inquiryModal.emailPlaceholder')}
          onChange={(e) => {
            formState.contactEmail = e.target.value
            refreshOkState()
          }}
        />
      </div>
      <div className={styles.field}>
        <span className={styles.label}>{i18n.t('inquiryModal.messageLabel')}</span>
        <TextArea
          rows={4}
          maxLength={1000}
          placeholder={i18n.t('inquiryModal.messagePlaceholder')}
          defaultValue={formState.inquiryMessage}
          onChange={(e) => {
            formState.inquiryMessage = e.target.value
            refreshOkState()
          }}
        />
      </div>
    </div>
  )

  const modal = confirmBase({
    title: i18n.t('inquiryModal.title'),
    width: 520,
    content: buildContent(),
    okText: i18n.t('inquiryModal.submit'),
    cancelText: i18n.t('inquiryModal.cancel'),
    okButtonProps: {
      className: 'type8 h38',
      style: { minWidth: '100px' },
      disabled: !canSubmit(),
    },
    maskClosable: false,
    onOk: async () => {
      try {
        await WorkspaceService.requestInquiry(
          workspaceName || '',
          formState.contactEmail,
          formState.inquiryMessage,
        )
        message.success(i18n.t('inquiryModal.successMessage'))
      } catch (e) {
        // 429(쿨타임) 안내는 공통 통로(services/jwt customFetch)가 이미 띄운다 — 중복 팝업 방지.
        // throw 는 유지해야 팝업이 닫히지 않아 사용자가 입력한 문의 내용을 잃지 않는다.
        if (e?.code !== 429) {
          errorBase({
            title: i18n.t('inquiryModal.errorTitle'),
            content: i18n.t('inquiryModal.errorMessage'),
          })
        }
        throw e
      }
    },
  })

  return modal
}

export default openInquiryConfirm
